var RulesQueryKeys={global:['rules']};export{RulesQueryKeys};